import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { DbtJobRuns } from "./DbtJobRuns";

export const DbtJobRunsWithProvider = () => (
  <DatatableContextProvider>
    <DbtJobRuns />
  </DatatableContextProvider>
);
